import { BASE_URL } from "@/Routes";
import { RouteResponseRequest } from "./RoutePreview.types";
import { type BookingPayload } from "@/redux";

export const getRouteEstimates = async (
  route: BookingPayload
): Promise<RouteResponseRequest> => {
  const link = `${BASE_URL}/pricingestimate`

  const res = await fetch(link, {
    method: "POST",
    headers: {
      "Content-Type": "application/json",
    },
    body: JSON.stringify(route),
  });

  if (!res.ok) {
    throw new Error("Failed to fetch route");
  }

  const data: RouteResponseRequest = await res.json();

  return data;
};